import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './FormInput.scss';

export const FormInputContext = React.createContext({
  required: false,
  valid: true,
});

class FormInput extends React.Component {
  static propTypes = {
    /** custom classname to add to the component. */
    className: PropTypes.string,
    /** Label in FormInput */
    label: PropTypes.element.isRequired,
    /** input component in FormInput */
    input: PropTypes.element.isRequired,
    /** whether the input is valid or not. */
    valid: PropTypes.bool,
    /** error text to show if not valid. */
    error: PropTypes.string,
    /** whether the input is required or not. */
    required: PropTypes.bool,
    /** descriptions of input label. */
    descriptions: PropTypes.arrayOf(PropTypes.string),
  };

  static defaultProps = {
    className: '',
    valid: true,
    error: '필수로 응답해야 하는 문항입니다.',
    required: false,
    descriptions: [],
  };

  getContext() {
    const { required, valid } = this.props;
    return {
      required,
      valid,
    };
  }

  render() {
    const { className, label, input, descriptions, error, valid } = this.props;

    return (
      <FormInputContext.Provider value={this.getContext()}>
        <div
          className={classnames('common-form-input', className, {
            'common-form-input--invalid': !valid,
          })}
        >
          {label}
          <div className="common-form-input__descriptions">
            {descriptions.map((desc, i) => (
              <div key={i} className="common-form-input__description">
                {desc}
              </div>
            ))}
          </div>
          {input}
          {!valid && (
            <div className="common-form-input__error">
              <i className="fa fa-check" />
              {error}
            </div>
          )}
        </div>
      </FormInputContext.Provider>
    );
  }
}

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/common/form-input/FormInput.js